import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  newContactState: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
    data: null,
  },
};

export const addNewContactSlice = createSlice({
  name: "newContact",
  initialState: INITIAL_STATE,
  reducers: {
    addNewContact: (state) => {
      state.newContactState.isLoading = true;
    },
    addNewContactSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      newContactState: {
        ...state.newContactState,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    addNewContactFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      newContactState: {
        ...state.newContactState,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
  },
});

export const { addNewContact, addNewContactFailure, addNewContactSuccess } =
  addNewContactSlice.actions;
export const addNewContactReducer = addNewContactSlice.reducer;
